module.exports = __webpack_public_path__ + "img/corrugatedBox13.48d9d3f6.jpg";